import Vue, { PluginObject } from 'vue';

/**
 * Modal option data.
 */
export interface ModalOption {
  label?: string;
  action?: () => void;
}

/**
 * Modal data used by the plugin.
 */
export interface ModalData {
  title?: string;
  text?: string;
  positive?: ModalOption;
  negative?: ModalOption;
}

export interface ModalPlugin {
  open(data: ModalData): void;
}

export class ModalPluginObject implements PluginObject<unknown>, ModalPlugin {

  /** Inner event bus used to catch events. */
  private eventBus!: Vue;

  install(VueInstance: typeof Vue) {
      // Create a new event bus.
      this.eventBus = new Vue();
      // Expose global $modal object.
      VueInstance.prototype.$modal = this;
  }

  /** Register open listener on modal. */
  public register(openListener: (data: ModalData) => void) {
    this.eventBus.$on('open', openListener);
  }

  public open(data: ModalData): void {
    this.eventBus.$emit('open', data);
  }
}

const modal = new ModalPluginObject();
Vue.use(modal);
export default modal;

/**
 * Typescript support.
 */
declare module 'vue/types/vue' {
  interface Vue {
    $modal: ModalPlugin;
  }
}
